<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Redeeming Transcendence in the Arts: Bearing Witness to the Triune God</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<p class="OT"><a id="page_vi"></a><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="TocSb1" id="ack1"><a id="page_vii"></a><a href="#/xhtml/Acknowledgments#ack">Acknowledgments</a></p>
<p class="Toc" id="int1"><a href="#/xhtml/Introduction#int">Introduction</a></p>
<p class="Toc1" id="c1"><a href="#/xhtml/Chapter001#ch01">1.<span class="space1">Stirrings of Transcendence?</span></a></p>
<p class="Toc1" id="c2"><span href="#/xhtml/Chapter002#ch02" title="Link target outside of Sample">2.<span class="space1">Sublime Transcendence</span></span></p>
<p class="Toc1" id="c3"><span href="#/xhtml/Chapter003#ch03" title="Link target outside of Sample">3.<span class="space1">Disturbing Transcendence</span></span></p>
<p class="Toc1" id="c4"><span href="#/xhtml/Chapter004#ch04" title="Link target outside of Sample">4.<span class="space1">Redeeming Transcendence</span></span></p>
<p class="Toc" id="con1"><span href="#/xhtml/Conclusion#con" title="Link target outside of Sample">Conclusion</span></p>
<p class="Toc2" id="bib1"><span href="#/xhtml/Bibliography#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="Toc2" id="ind1_1"><span href="#/xhtml/Index001#ind1-1" title="Link target outside of Sample">Index of Names</span></p>
<p class="Toc2" id="ind2_1"><span href="#/xhtml/Index002#ind2-1" title="Link target outside of Sample">Index of Subjects</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?73387bf1